import { render, staticRenderFns } from "./ThirdStepAssistance.vue?vue&type=template&id=7f52d3a0&"
import script from "./ThirdStepAssistance.vue?vue&type=script&lang=js&"
export * from "./ThirdStepAssistance.vue?vue&type=script&lang=js&"
import style0 from "./ThirdStepAssistance.vue?vue&type=style&index=0&id=7f52d3a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports